import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getCertificate (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getCertificate)
    })
  } else {
    const req = {
      url: '/api/certificados/getcertificado',
      method: 'GET',
      params: params,
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getCertificate }
